
import { defineComponent } from "vue";
import GameService from "@/services/GameService";
import ResponseData from "@/_models/ResponseData";
import store from "@/store/index";
import { Helper } from "@/utils/Helper";
import GamesGalleryComponent from "./gallery/gamesGalleryComponent.vue";

export default defineComponent({
    data: function () {
        return {
            file: "",
            preview: [],
            remove: "",
            fileSizeError: "",
            fileTypeError: "",
            userData: store.getters["auth/user"] ?? "",
            jwtToken: store.getters["auth/jwtToken"] ?? "",
            hasChanged: false,
            isDisabledSaveButton: true,
            isUploading: false,
            galleryKey: 0,
            gallery: [],
        };
    },
    name: "gamesTabGamePageGalleryComponent",
    methods: {
        handleFileUpload(event: any) {
            if (event.target.files.length <= 9 && event.target.files.length > 0) {
                this.hasChanged = true;
  
                if (this.file != "") {
                  this.file = Array.from(this.file).concat(Array.from(event.target.files));
                } else {
                  this.file = event.target.files;
                }
                
                this.isDisabledSaveButton = false;
                this.preview = [];
                for (let i = 0; i < this.file.length; i++) {
                    const file = this.file[i];
                    const preview = URL.createObjectURL(file);
                    this.preview.push(preview);
                }
            }
            else {
                Helper.endpointErrorHandling("", "Number of files exceeded the limit!");
            }
        },
        removeFile(item: any) {
            this.file = Array.from(this.file);
            for (let i = 0; i < this.file.length; i++) {
                if (this.file[i].name == item) {
                  this.file.splice(i, 1);
                  this.preview.splice(i, 1);
                }
            }
            if (this.file.length == 0) {
                this.isDisabledSaveButton = true;
            }
        },
        removeAllFiles() {
            for (let i = 0; i < this.file.length; i++) {
                this.file = "";
                this.preview = [];
            }
            this.isDisabledSaveButton = true;
        },
        forceRerenderGallery() {
          this.galleryKey += 1;
        },
        addImageGallery() {
            this.isUploading = true;
            this.isDisabledSaveButton = true;
            let gameId = this.$route.params.gameId.toString();
            let formData = new FormData();
            if (this.file !== "") {
                for (let i = 0; i < this.file.length; i++) {
                    formData.append("ImageStreams", this.file[i]);
                }
                GameService.updateGameGallery(gameId, this.userData.userId, this.jwtToken, formData)
                    .then((response: ResponseData) => {
                    Helper.toastSuccessHandling(response.data["message"]);
                    this.removeAllFiles();
                    this.isUploading = false;
                    this.forceRerenderGallery();
                }).catch((error) => {
                    Helper.endpointErrorHandling(error);
                });
            }
        },

        getGameDetails() {
          if (this.$route.params.gameId !== undefined && this.userData !== "") {
            let gameId = this.$route.params.gameId.toString();
    
            GameService.getGame(gameId)
              .then((response: ResponseData) => {
                if (response.status === 200) {
                  this.gameDetails = response.data.viewModel.game;
                  this.username = this.userData.username;
                  this.gameDetails.created = Helper.formatDate(this.gameDetails.created);
                  this.gameDetails.updated = Helper.formatDate(this.gameDetails.updated);
    
                  if (response.data.viewModel.details !== null && response.data.viewModel.details.about !== null) {
                    this.about = response.data.viewModel.details.about.about;
                  }
    
                  if (response.data.viewModel.details !== null && response.data.viewModel.details.gallery.headerImage !== null) {
                    this.coverImage = this.assetUrl + "blob/games/" + gameId + "/gallery/" + response.data.viewModel.details.gallery.headerImage;
                  }
    
                  if (response.data.viewModel.details !== null && response.data.viewModel.details.gallery.galleryImages !== []) {
                    response.data.viewModel.details.gallery.galleryImages.forEach((image, index) => {
                      this.gallery.push({
                        id: index + 1,
                        url: this.assetUrl + "blob/games/" + gameId + "/gallery/" + image,
                        itemCount: index + 1,
                        display: index > 2 ? false : true,
                      });
                    });
                  }
                  // this.maxStep = this.gallery.length <= 3 ? 0 : Math.floor(this.gallery.length / 3);
                  // this.gallery = this.groupGalleryByThree(this.gallery);
                }
              })
              .catch((error) => {
                Helper.endpointErrorHandling(error);
              });
          }
        },

    },
    mounted() {
        this.getGameDetails();
      },
    components: { GamesGalleryComponent }
});
